import app from '@/main'

async function abuseReportReasonsGet () {
  return await app.wsp.sendRequest({
    data: {},
    method: 'abuseReportReasons.get'
  })
}

export default abuseReportReasonsGet